// role.guard.ts
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanMatchFn, Router } from '@angular/router';
import { LoggedOnUserPermissionsStore } from 'app/store/permissions.auth.store';
import { filter, map, of, switchMap, take } from 'rxjs';

export const roleGuard = (config: { requiresAdmin: boolean }): CanMatchFn => {
  return () => {
    const router = inject(Router);
    const permissionsStore = inject(LoggedOnUserPermissionsStore);

    // 🟢 Wait until isLoading is false (or isInitialized is true)
    return toObservable(permissionsStore.isLoaded).pipe(
      filter(Boolean),
      take(1),
      switchMap(() => {
        const isColleague = permissionsStore.isAmexColleague();

        if (config.requiresAdmin === isColleague) {
           return of(true);
        }

         return of(router.parseUrl('error'));
      })
    );
  };
};